import { render, staticRenderFns } from "./AppUserMsgBlock.vue?vue&type=template&id=68bb9a1a&scoped=true"
import script from "./AppUserMsgBlock.vue?vue&type=script&lang=js"
export * from "./AppUserMsgBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb9a1a",
  null
  
)

export default component.exports